import type { ComponentProps, ReactNode } from "react";
import { Search as SearchIcon, Filter, Plus } from "lucide-react";
import { Button } from "./ui/button";

export const Root = ({ children }: { children: ReactNode }) => (
  <div className="flex items-center gap-3 mb-4">{children}</div>
);

export const Search = ({
  value,
  onChange,
  placeholder = "Search documents, authors, keywords...",
  className = "flex-1",
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Sizing for the wrapper. Defaults to filling the toolbar row; pass a fixed
   *  width where the search sits beside something else. */
  className?: string;
}) => (
  <div className={`${className} relative`}>
    <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full pl-10 pr-4 py-2.5 border rounded-md text-sm bg-card focus:outline-none focus:ring-2 focus:ring-brand-teal/30"
    />
  </div>
);

export const FiltersToggle = ({
  open,
  active,
  onToggle,
}: {
  open: boolean;
  active: boolean;
  onToggle: () => void;
}) => (
  <Button variant={open || active ? "default" : "outline"} onClick={onToggle}>
    <Filter /> Filters
  </Button>
);

export const FilterPanel = ({
  open,
  children,
}: {
  open: boolean;
  children: ReactNode;
}) =>
  open ? (
    <div className="flex items-end gap-4 mb-4 pb-4 border-b">{children}</div>
  ) : null;

export const SelectedCount = ({ count }: { count: number }) =>
  count > 0 ? (
    <span className="inline-flex items-center gap-1.5 bg-brand-yellow text-black text-sm font-medium px-4 py-2.5">
      {count} selected
    </span>
  ) : null;

export const UploadButton = ({ onClick, variant, appearance }: {
  onClick: () => void,
  variant?: ComponentProps<typeof Button>['variant']
  appearance?: ComponentProps<typeof Button>['appearance']
}) => (
  <Button
    variant={variant ?? 'brand'}
    appearance={appearance ?? 'outlined'}
    onClick={onClick}
  >
    <Plus /> Upload
  </Button>
);
